var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExplore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_288_786",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_288_786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2655 34.2346L27.7077 27.2385L34.7038 13.7962L21.2616 20.7924L14.2655 34.2346ZM24.5 26C23.9333 26 23.4583 25.8083 23.075 25.425C22.6917 25.0417 22.5 24.5667 22.5 24C22.5 23.4333 22.6917 22.9583 23.075 22.575C23.4583 22.1917 23.9333 22 24.5 22C25.0667 22 25.5417 22.1917 25.925 22.575C26.3083 22.9583 26.5 23.4333 26.5 24C26.5 24.5667 26.3083 25.0417 25.925 25.425C25.5417 25.8083 25.0667 26 24.5 26ZM24.5034 43C21.896 43 19.4394 42.5013 17.1335 41.504C14.8276 40.5066 12.8112 39.1448 11.0841 37.4185C9.35693 35.6921 7.99448 33.6765 6.99671 31.3717C5.99894 29.0668 5.50006 26.6107 5.50006 24.0034C5.50006 21.3755 5.99873 18.9054 6.99606 16.5932C7.99339 14.2808 9.35523 12.2695 11.0816 10.5591C12.8079 8.84859 14.8235 7.49447 17.1284 6.4967C19.4332 5.49894 21.8893 5.00005 24.4967 5.00005C27.1245 5.00005 29.5946 5.49872 31.9069 6.49605C34.2192 7.49339 36.2305 8.84688 37.941 10.5566C39.6514 12.2663 41.0055 14.2767 42.0033 16.588C43.0011 18.8992 43.5 21.3688 43.5 23.9967C43.5 26.604 43.0013 29.0606 42.004 31.3665C41.0066 33.6724 39.6531 35.6889 37.9435 37.416C36.2338 39.1431 34.2233 40.5055 31.912 41.5033C29.6008 42.5011 27.1312 43 24.5034 43ZM24.5 40.7308C29.1564 40.7308 33.109 39.1013 36.3577 35.8423C39.6064 32.5833 41.2308 28.6359 41.2308 24C41.2308 19.3436 39.6064 15.391 36.3577 12.1423C33.109 8.8936 29.1564 7.26925 24.5 7.26925C19.8641 7.26925 15.9167 8.8936 12.6577 12.1423C9.39875 15.391 7.76926 19.3436 7.76926 24C7.76926 28.6359 9.39875 32.5833 12.6577 35.8423C15.9167 39.1013 19.8641 40.7308 24.5 40.7308Z",
    fill: "#233DFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplore);
export default __webpack_public_path__ + "static/media/explore.f2c76407edc2ae2b860d558b24dac466.svg";
export { ForwardRef as ReactComponent };